import { setUserSession, checkUserSession } from './checkUserSession';

// PACKAGES
import axios, { AxiosError, AxiosResponse } from 'axios';

// UTILS
import { isObject, SITE_KEY } from '../utils';

// MODELS
import {
	AccountCertificationQueryResponse,
	AccountChangeEmailCommand,
	AccountEditPhoneNumberCommand,
	AccountEmailVerificationResponse,
	AccountExistingCertificationsResponse,
	AccountJoinOrganisationResponse,
	AccountLinkAccountsCommand,
	AccountLinkChildNameCommand,
	AccountLinkRequestApproveCommand,
	AccountLinkRequestRejectCommand,
	AccountLinkRequestRemoveCommand,
	AccountLinkRequestResponse,
	AccountLinkRequestRevokeCommand,
	AccountMyAccountResponse,
	AccountParentVerificationQueryResponse,
	AccountUserResponse,
	AccountVolunteerRequestCommand,
	AccountVolunteerRevokeCommand,
	AuditReadyResponse,
	AuthenticationLoginResponse,
	AuthenticationResendTwoFactorTokenCommand,
	AuthenticationSwitchProfileResponse,
	AuthenticationValidateTwoFactorCommand,
	AuthenticationValidateTwoFactorResponse,
	ChecklistTemplateDashboardResponse,
	ChecklistTemplateEditQueryResponse,
	ChildSafeStandardAdminDashboardResponse,
	ChildSafeStandardEditQueryResponse,
	ChildSafeStandardFetchResponse,
	ChildSafeStandardUserDashboardResponse,
	ComplaintAcceptResolutionQueryResponse,
	ComplaintActionsResponse,
	ComplaintAdminDashboardResponse,
	ComplaintAdviceDashboardResponse,
	ComplaintAdviceEditResponse,
	ComplaintComplaintAdviceResponse,
	ComplaintFetchResponse,
	ComplaintMemberCandidatesResponse,
	ComplaintResolutionResponse,
	ComplaintStaffCandidatesResponse,
	ComplaintUserDashboardResponse,
	DashboardActivityFeedQueryResponse,
	DashboardSectionSummariesResponse,
	DomainProfileType,
	FamiliesDashboardResponse,
	FamiliesFetchResponse,
	FamiliesPastResponse,
	FamiliesReinstateProfileCommand,
	FeedbackActionsResponse,
	FeedbackAdminDashboardResponse,
	FeedbackFetchResponse,
	FeedbackUserDashboardResponse,
	GlobalLookupsResponse,
	HelpDeskAdminDashboardResponse,
	HelpDeskEditQueryResponse,
	HelpDeskFetchResponse,
	HelpDeskUserDashboardResponse,
	IncidentAcknowledgeOnBehalfQueryResponse,
	IncidentAdminDashboardResponse,
	IncidentArchiveAcknowledgeOnBehalfQueryResponse,
	IncidentArchiveEditQueryResponse,
	IncidentArchiveLinkIncidentCommand,
	IncidentArchiveLinkRequestResponse,
	IncidentArchiveRecipientsResponse,
	IncidentEditQueryResponse,
	IncidentLinkRequestResponse,
	IncidentRecipientsResponse,
	IncidentUserDashboardResponse,
	InviteInviteLinksResponse,
	LeadershipTeamMembersResponse,
	LeadershipTeamSearchResponse,
	NavigationActionTickerResponse,
	NavigationMenuAccessRightsResponse,
	OrganisationAddressQueryResponse,
	OrganisationAdministratorCandidatesResponse,
	OrganisationAdministratorsResponse,
	OrganisationAustralianBusinessNumberResponse,
	OrganisationDetailsResponse,
	OrganisationFindResponse,
	OrganisationListResponse,
	OrganisationPaymentInfoCommand,
	OrganisationPaymentInfoResponse,
	OrganisationProfileCheckResponse,
	OrganisationRegistrationQueryResponse,
	OrganisationRegistrationResponse,
	OrganisationSearchResponse,
	OrganisationSettingsResponse,
	PaymentCreateResponse,
	PaymentPlansResponse,
	PolicyAdminDashboardResponse,
	PolicyEditQueryResponse,
	PolicyPolicyTemplatesResponse,
	PolicyTemplateDashboardResponse,
	PolicyTemplateEditQueryResponse,
	PolicyUserDashboardResponse,
	RequestsToJoinFetchResponse,
	RequestsToJoinPendingRequestsResponse,
	RequestsToJoinReviewCertificationResponse,
	RequestsToJoinVolunteerApproveCommand,
	RequestsToJoinVolunteerDenyCommand,
	SafetyChecklistAdminDashboardResponse,
	SafetyChecklistApproversResponse,
	SafetyChecklistAttachmentsResponse,
	SafetyChecklistChecklistResponse,
	SafetyChecklistCommentQueryResponse,
	SafetyChecklistEditQueryResponse,
	SafetyChecklistTemplateResponse,
	SafetyChecklistTemplatesResponse,
	SafetyChecklistUserDashboardResponse,
	SharedModelsCommandIdResponse,
	SharedModelsCommandResponse,
	StaffDashboardResponse,
	StaffFetchResponse,
	StaffPastResponse,
	StaffReferenceQueryResponse,
	StaffReinstateProfileCommand,
	TrainingAdditionalTrainingEditQueryResponse,
	TrainingAdminDashboardResponse,
	TrainingEditModuleQueryResponse,
	TrainingModuleDashboardResponse,
	TrainingModuleEditQueryResponse,
	TrainingUserDashboardResponse,
	TrainingViewResponse,
	UploadTokenResponse,
	VisitorsDashboardResponse,
	VisitorsFetchResponse,
	VisitorsPastResponse,
	VisitorsReinstateProfileCommand,
	WorkingWithChildrenCheckSingleStatusCheckCommand
} from '../api/models';
import { AccountEditProfileImageCommand } from '../api/models';
import { AccountEmailChangeRequestCommand } from '../api/models';
import { AuthenticationChangePasswordCommand } from '../api/models';
import { OrganisationActivateCommand } from '../api/models';
import { OrganisationAddAdministratorCommand } from '../api/models';
import { PaymentCreateCommand } from '../api/models';
import { StaffReferenceCommand } from '../api/models';
import { OrganisationDeactivateCommand } from '../api/models';
import { UploadTokenCommand } from '../api/models';
import { UploadTokenAzureStorageSasResult } from '../api/models';
import { AuthenticationForgotPasswordCommand } from '../api/models';
import { AuthenticationResetPasswordCommand } from '../api/models';
import { AuthenticationLoginCommand } from '../api/models';
// import { AuthenticationLoginResponse } from '../api/models';
import { AuthenticationTokenRefreshCommand } from '../api/models';
import { AuthenticationTokenRefreshResponse } from '../api/models';
import { AuthenticationSwitchProfileCommand } from '../api/models';
import { AccountRegistrationCommand } from '../api/models';
import { AccountSendEmailVerificationCommand } from '../api/models';
import { OrganisationRegistrationCommand } from '../api/models';
import { AccountJoinOrganisationCommand } from '../api/models';
import { LeadershipTeamUnAssignCommand } from '../api/models';
import { LeadershipTeamAssignCommand } from '../api/models';
import { AccountCertificationCommand } from '../api/models';
import { IncidentArchiveAcknowledgeOnBehalfCommand } from '../api/models';
import { IncidentAcknowledgeOnBehalfCommand } from '../api/models';
import { PolicyAcknowledgeCommand } from '../api/models';
import { TrainingModuleEditCommand } from '../api/models';
import { DashboardActivityFeedCommand } from '../api/models';
import { DashboardRemoveActivityFeedCommand } from '../api/models';
import { FeedbackCreateCommand } from '../api/models';
import { FeedbackResolveCommand } from '../api/models';
import { FeedbackLogActionCommand } from '../api/models';
import { FeedbackWithdrawCommand } from '../api/models';
import { SafetyChecklistSubmitCommand } from '../api/models';
import { SafetyChecklistActionCommand } from '../api/models';
import { SafetyChecklistApproveCommand } from '../api/models';
import { SafetyChecklistAttachmentDeleteCommand } from '../api/models';
import { SafetyChecklistAttachmentUploadCommand } from '../api/models';
import { SafetyChecklistCommentCommand } from '../api/models';
import { SafetyChecklistEditCommand } from '../api/models';
import { StaffStaffTypeCommand } from '../api/models';
import { StaffDisableProfileCommand } from '../api/models';
import { VisitorsDisableProfileCommand } from '../api/models';
import { FamiliesDisableProfileCommand } from '../api/models';
import { StaffOrganisationAdminCommand } from '../api/models';
import { IncidentArchiveEditCommand } from '../api/models';
import { IncidentArchiveAcknowledgeCommand } from '../api/models';
import { IncidentAcknowledgeCommand } from '../api/models';
import { IncidentEditCommand } from '../api/models';
import { IncidentLinkIncidentCommand } from '../api/models';
import { boundProgressType } from '../components/FileUpload';
import { ChildSafeStandardDeleteCommand } from '../api/models';
import { ChildSafeStandardEditCommand } from '../api/models';
import { ChildSafeStandardReorderCommand } from '../api/models';
import { ComplaintAdviceEditCommand } from '../api/models';
import { ComplaintAdviceDeleteCommand } from '../api/models';
import { ComplaintAdviceReorderCommand } from '../api/models';
import { PolicyTemplateDeleteCommand } from '../api/models';
import { PolicyTemplateEditCommand } from '../api/models';
import { PolicyTemplateReorderCommand } from '../api/models';
import { TrainingModuleDeleteCommand } from '../api/models';
import { TrainingModuleReorderCommand } from '../api/models';
import { TrainingAdditionalTrainingEditCommand } from '../api/models';
import { TrainingEditCommand } from '../api/models';
import { TrainingMarkAsCompleteCommand } from '../api/models';
import { TrainingRemoveCommand } from '../api/models';
import { TrainingEditModuleCommand } from '../api/models';
import { TrainingDeleteModuleCommand } from '../api/models';
import { ChecklistTemplateDeleteCommand } from '../api/models';
import { ChecklistTemplateReorderCommand } from '../api/models';
import { ChecklistTemplateEditCommand } from '../api/models';
import { RequestsToJoinDenyCommand } from '../api/models';
import { RequestsToJoinApproveCommand } from '../api/models';
import { RequestsToJoinStaffTypeCommand } from '../api/models';
import { RequestsToJoinOrganisationAdminCommand } from '../api/models';
import { RequestsToJoinCiteCertificationCommand } from '../api/models';
import { PolicyArchiveCommand } from '../api/models';
import { PolicyReinstateCommand } from '../api/models';
import { PolicyEditCommand } from '../api/models';
import { ComplaintCreateCommand } from '../api/models';
import { ComplaintResolutionCommand } from '../api/models';
import { ComplaintEditActionCommand } from '../api/models';
import { ComplaintRemoveActionCommand } from '../api/models';
import { ComplaintAcceptResolutionCommand } from '../api/models';
import { ComplaintReopenCommand } from '../api/models';
import { ComplaintWithdrawCommand } from '../api/models';
import { ComplaintAddStaffCommand } from '../api/models';
import { ComplaintRemoveFamilyMemberCommand } from '../api/models';
import { OrganisationAddressCommand } from '../api/models';
import { OrganisationEditProfileImageCommand } from '../api/models';
import { OrganisationRemoveAdministratorCommand } from '../api/models/organisation-remove-administrator-command';
import { HelpDeskReorderCommand } from '../api/models';
import { HelpDeskDeleteCommand } from '../api/models';
import { HelpDeskEditCommand } from '../api/models';
import { OrganisationNumberOfChildrenCommand } from '../api/models';
import { AccountParentVerificationCommand } from '../api/models';

// API
import azureFileUpload from './azure-file-upload';
import { IncompleteProfileApi, SafetyChecklistApi } from '../api/api';
import { TrainingApi } from '../api/api';
import { UploadApi } from '../api/api';
import { PolicyTemplateApi } from '../api/api';
import { ComplaintAdviceApi } from '../api/api';
import { ChildSafeStandardApi } from '../api/api';
import { TrainingModuleApi } from '../api/api';
import { ChecklistTemplateApi } from '../api/api';
import { GlobalApi } from '../api/api';
import { AuthenticationApi } from '../api/api';
import { AccountApi } from '../api/api';
import { OrganisationApi } from '../api/api';
import { VisitorsApi } from '../api/api';
import { NavigationApi } from '../api/api';
import { DashboardApi } from '../api/api';
import { LeadershipTeamApi } from '../api/api';
import { RequestsToJoinApi } from '../api/api';
import { FeedbackApi } from '../api/api';
import { InviteApi } from '../api/api';
import { IncidentArchiveApi } from '../api/api';
import { IncidentApi } from '../api/api';
import { StaffApi } from '../api/api';
import { FamiliesApi } from '../api/api';
import { PolicyApi } from '../api/api';
import { ComplaintApi } from '../api/api';
import { PaymentApi } from '../api/api';
import { AuditApi } from '../api/api';
import { HelpDeskApi } from '../api/api';
import { WorkingWithChildrenCheckApi } from '../api/api';

interface AccountEmailVerificationCommand {
	token?: string;
	email?: string;
}

export type ResponseStandardFail = {
	detail?: string;
	errors?: {
		message?: string;
		type?: string;
	}[];
	isError: true;
	status?: number;
	type?: string;
	validationErrors: {
		name?: string;
		reason?: string;
	}[];
} & {
	message: string; // custom field that was added by FED, it seems
};

interface RequestErrorTypes {
	isError: true;
	message: string;
	validationErrors: {
		name?: string;
		reason?: string;
	}[];
}

const api = () => {
	let tokenTimer: ReturnType<typeof setTimeout>;

	document.cookie = `CATimezoneOffset=${new Date().getTimezoneOffset()};max-age=${
		30 * 24 * 60 * 60
	};secure;samesite=strict;path=/`;

	const authenticationTokenRefresh = async () => {
		const fields: AuthenticationTokenRefreshCommand = {
			token: localStorage.getItem('token') || '',
			refreshToken: localStorage.getItem('refreshToken') || ''
		};

		return new AuthenticationApi().apiAuthenticationTokenrefreshPost(fields);
	};

	const destroyToken = () => {
		clearTimeout(tokenTimer);
		setUserSession(null);
		localStorage.removeItem('token');
		localStorage.removeItem('refreshToken');
		document.cookie = `AuthorizationToken=;expires=Thu, 01 Jan 1970 00:00:00 GMT;secure;samesite=strict`;
	};

	// initialisation
	// before request
	axios.interceptors.request.use(
		(config) => {
			const token = localStorage.getItem('token') || '';

			if (token) {
				config.headers = {
					...config.headers,
					Authorization: `Bearer ${token}`,
					CATimezoneOffset: new Date().getTimezoneOffset()
				};
			}

			return config;
		},
		(error) => {
			return Promise.reject(error);
		}
	);

	// before response
	axios.interceptors.response.use(
		(response: any) => {
			// Any status code that lie within the range of 2xx cause this function to trigger

			if (response.data && response.data.result) {
				if (response.data.result.token) {
					const maxAge =
						response.data.result.cookieExpiry !== undefined ? response.data.result.cookieExpiry * 60 : 86400;
					const token = response.data.result.token;
					setUserSession(token);
					localStorage.setItem('token', token);
					document.cookie = `AuthorizationToken=${token};max-age=${maxAge};secure;samesite=strict;path=/`;

					// should output something reasonable like (30 mins - 5 mins). Or 5 mins if something goes wrong
					const tokenInterval = (maxAge - 300 > 300 ? maxAge - 300 : 300) * 1000; // seconds to milliseconds

					// setup a timeout to run again before the token expires
					clearTimeout(tokenTimer);
					tokenTimer = setTimeout(() => {
						authenticationTokenRefresh();
					}, tokenInterval);
				}

				if (response.data.result.refreshToken) {
					const refreshToken = response.data.result.refreshToken;
					localStorage.setItem('refreshToken', refreshToken);
				}
			}

			// Retry axios request 1 time if recaptcha token is bad
			if (
				response.data &&
				response.data.isError &&
				response.data.validationErrors[0].name === 'CaptchaToken' &&
				response.data.validationErrors[0].reason === 'Recaptcha token is invalid.'
			) {
				const originalRequest = response.config;

				if (!originalRequest._captchaRetry && window.grecaptcha) {
					originalRequest._captchaRetry = true;

					const params = JSON.parse(originalRequest.data);

					return new Promise((resolve) => {
						window.grecaptcha.ready(() => {
							window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then((token: string) => {
								params.captchaToken = token;
								originalRequest.data = JSON.stringify(params);
								resolve(axios(originalRequest));
							});
						});
					});
				}
			}

			return response;
		},
		(error) => {
			// Any status codes that falls outside the range of 2xx cause this function to trigger

			if (error && error.response && error.response.status === 401) {
				const originalRequest = error.config;

				if (!originalRequest._retry) {
					originalRequest._retry = true;

					return authenticationTokenRefresh()
						.then((response: any) => {
							if (response.data.isError) {
								// token refresh failed
								destroyToken();
							}
							return axios(originalRequest);
						})
						.catch((error: any) => {
							// token refresh failed
							destroyToken();
						});
				} else {
					// 2 x 401 error in a row - token refresh failed
					destroyToken();
				}
			}

			return Promise.reject(error);
		}
	);

	async function request<T>(apiCall: any): Promise<(T & { isError: false }) | ResponseStandardFail> {
		// check for multiple tabs that are logged in
		checkUserSession();

		return apiCall()
			.then((response: AxiosResponse<T>) => {
				return response.data;
			})
			.catch((error: AxiosError<ResponseStandardFail>) => {
				const errorData: RequestErrorTypes = {
					isError: true,
					message: 'An error has occurred',
					validationErrors: []
				};

				if (error) {
					if (error.response && isObject(error.response.data)) {
						// Request made and server responded
						errorData.message = error.response.data.detail || errorData.message;
						if (error.response.data.validationErrors) {
							errorData.validationErrors = [...error.response.data.validationErrors];
						}
					} else if (error.request) {
						// The request was made but no response was received
						errorData.message = 'A communication error has occurred';

						// fix for cloudflare expiry on Dev and Staging
						if (window.location.host.indexOf('studiobravo') !== -1) {
							window.location.reload();
						}
					}
				}

				console.log(errorData);
				return errorData;
			});
	}

	return {
		// GLOBAL
		async getGlobalLookups() {
			return request<GlobalLookupsResponse>(new GlobalApi().apiGlobalLookupsGet.bind(this));
		},

		async refreshAuthenticationToken() {
			// special case - no need to bind
			return request<AuthenticationTokenRefreshResponse>(authenticationTokenRefresh);
		},

		async getUploadCredentials(file: File, token: string) {
			// get azure credentials

			const fields: UploadTokenCommand = { fileName: file.name, captchaToken: token };

			return request<UploadTokenResponse>(new UploadApi().apiUploadTokenPost.bind(this, fields));
		},

		async uploadFile(file: File, credentials: UploadTokenAzureStorageSasResult, progressCallback?: boundProgressType) {
			return await azureFileUpload(file, credentials, progressCallback);
		},

		async getMainMenu() {
			return request<NavigationMenuAccessRightsResponse>(
				new NavigationApi().apiNavigationMenuaccessrightsGet.bind(this)
			);
		},

		async getNavigationActionTicker() {
			return request<NavigationActionTickerResponse>(new NavigationApi().apiNavigationActiontickerGet.bind(this));
		},

		async getUserDetails() {
			return request<AccountUserResponse>(new AccountApi().apiAccountUserGet.bind(this));
		},

		async doSwitchOrganisation(fields: AuthenticationSwitchProfileCommand) {
			return request<AuthenticationSwitchProfileResponse>(
				new AuthenticationApi().apiAuthenticationSwitchprofilePost.bind(this, fields)
			);
		},

		// REGISTER
		async doCreateAccount(fields: AccountRegistrationCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountRegisterPost.bind(this, fields));
		},

		async doResendEmailVerification(fields: AccountSendEmailVerificationCommand) {
			return request<SharedModelsCommandResponse>(
				new AccountApi().apiAccountSendemailverificationPost.bind(this, fields)
			);
		},

		async doEmailConfirmation(fields: AccountEmailVerificationCommand) {
			return request<AccountEmailVerificationResponse>(
				new AccountApi().apiAccountEmailverificationPost.bind(this, fields)
			);
		},

		async doForgotPassword(fields: AuthenticationForgotPasswordCommand) {
			return request<SharedModelsCommandResponse>(
				new AuthenticationApi().apiAuthenticationForgotpasswordPost.bind(this, fields)
			);
		},

		async doResetPassword(fields: AuthenticationResetPasswordCommand) {
			return request<SharedModelsCommandResponse>(
				new AuthenticationApi().apiAuthenticationResetpasswordPost.bind(this, fields)
			);
		},

		async sendParentVerification(fields: AccountParentVerificationCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountParentverificationPost.bind(this, fields));
		},

		async getParentVerificationStatus(token: string, email: string, organisationIdentifier: string) {
			return request<AccountParentVerificationQueryResponse>(
				new AccountApi().apiAccountParentverificationGet.bind(this, token, email, organisationIdentifier)
			);
		},

		async checkAbnInUse(AustralianBusinessNumber: string, organisationId: string) {
			return request<OrganisationAustralianBusinessNumberResponse>(
				new OrganisationApi().apiOrganisationAustralianbusinessnumberGet.bind(
					this,
					organisationId,
					AustralianBusinessNumber
				)
			);
		},

		async doOrganisationSearch(searchTerm: string) {
			return request<OrganisationSearchResponse>(new OrganisationApi().apiOrganisationSearchGet.bind(this, searchTerm));
		},

		async getOrganisationByIdentifier(organisationIdentifier: string) {
			return request<OrganisationFindResponse>(
				new OrganisationApi().apiOrganisationFindGet.bind(this, organisationIdentifier)
			);
		},

		async getOrganisationPaymentinfo(id: string) {
			return request<OrganisationPaymentInfoResponse>(
				new OrganisationApi().apiOrganisationPaymentinfoGet.bind(this, id)
			);
		},

		async postOrganisationPaymentInfo(fields: OrganisationPaymentInfoCommand) {
			return request<SharedModelsCommandResponse>(
				new OrganisationApi().apiOrganisationPaymentinfoPost.bind(this, fields)
			);
		},

		async doRegisterOrganisation(fields: OrganisationRegistrationCommand) {
			return request<OrganisationRegistrationResponse>(
				new OrganisationApi().apiOrganisationRegistrationPost.bind(this, fields)
			);
		},

		async getOrganisationRegistration(id: string) {
			return request<OrganisationRegistrationQueryResponse>(
				new OrganisationApi().apiOrganisationRegistrationGet.bind(this, id)
			);
		},

		async doRegisterOrganisationPayment(organisationId: PaymentCreateCommand['organisationId']) {
			const fields = { organisationId };
			return request<PaymentCreateResponse>(new PaymentApi().apiPaymentCreatePost.bind(this, fields));
		},

		async doJoinOrganisation(fields: AccountJoinOrganisationCommand) {
			return request<AccountJoinOrganisationResponse>(
				new AccountApi().apiAccountJoinorganisationPost.bind(this, fields)
			);
		},

		async addCertification(fields: AccountCertificationCommand) {
			return request<SharedModelsCommandIdResponse>(new AccountApi().apiAccountCertificationPost.bind(this, fields));
		},

		async getAccountExistingCertifications() {
			return request<AccountExistingCertificationsResponse>(
				new AccountApi().apiAccountExistingcertificationsGet.bind(this)
			);
		},

		async getRequestsTojoinReviewCertification(id?: string, profileId?: string) {
			return request<RequestsToJoinReviewCertificationResponse>(
				new RequestsToJoinApi().apiRequeststojoinReviewcertificationGet.bind(this, id, profileId)
			);
		},

		async postAccountLinkChildName(fields: AccountLinkChildNameCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountLinkchildnamePost.bind(this, fields));
		},

		async postAccountLinkAccounts(fields: AccountLinkAccountsCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountLinkaccountsPost.bind(this, fields));
		},

		async postAccountLinkRequestRevoke(fields: AccountLinkRequestRevokeCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountLinkrequestrevokePost.bind(this, fields));
		},

		async postAccountLinkRequestRemove(fields: AccountLinkRequestRemoveCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountLinkrequestremovePost.bind(this, fields));
		},

		async getAccountLinkRequest(id?: string) {
			return request<AccountLinkRequestResponse>(new AccountApi().apiAccountLinkrequestGet.bind(this, id));
		},

		async postAccountLinkRequestApprove(fields: AccountLinkRequestApproveCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountLinkrequestapprovePost.bind(this, fields));
		},

		async postAccountLinkRequestReject(fields: AccountLinkRequestRejectCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountLinkrequestrejectPost.bind(this, fields));
		},

		// LOGIN
		async doLogin(fields: AuthenticationLoginCommand) {
			destroyToken();

			return request<AuthenticationLoginResponse>(
				new AuthenticationApi().apiAuthenticationLoginPost.bind(this, fields)
			);
		},

		async postAuthenticationValidateTwoFactor(fields: AuthenticationValidateTwoFactorCommand) {
			return request<AuthenticationValidateTwoFactorResponse>(
				new AuthenticationApi().apiAuthenticationValidatetwofactorPost.bind(this, fields)
			);
		},

		async postAuthenticationResendTwoFactorToken(fields: AuthenticationResendTwoFactorTokenCommand) {
			return request<SharedModelsCommandResponse>(
				new AuthenticationApi().apiAuthenticationResendtwofactortokenPost.bind(this, fields)
			);
		},

		async doLogout() {
			destroyToken();
		},

		// PLANS
		async getPlanTypes() {
			return request<PaymentPlansResponse>(new PaymentApi().apiPaymentPlansGet.bind(this));
		},

		// DASHBOARD
		async getDashboardItems() {
			return request<DashboardSectionSummariesResponse>(new DashboardApi().apiDashboardSectionsummariesGet.bind(this));
		},

		async postAccountWalkthroughComplete() {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountWalkthroughcompletePost.bind(this));
		},

		// ACTIVITY FEED
		async getActivityFeed() {
			return request<DashboardActivityFeedQueryResponse>(new DashboardApi().apiDashboardActivityfeedGet.bind(this));
		},

		async updateActivityFeed(fields: DashboardActivityFeedCommand) {
			return request<SharedModelsCommandIdResponse>(new DashboardApi().apiDashboardActivityfeedPost.bind(this, fields));
		},

		async deleteFeedItem(fields: DashboardRemoveActivityFeedCommand) {
			return request<SharedModelsCommandResponse>(
				new DashboardApi().apiDashboardRemoveactivityfeedPost.bind(this, fields)
			);
		},

		// MY ACCOUNT
		async getAccountMyAccount() {
			return request<AccountMyAccountResponse>(new AccountApi().apiAccountMyaccountGet.bind(this));
		},

		async postAccountEmailChangeRequest(fields: AccountEmailChangeRequestCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountEmailchangerequestPost.bind(this, fields));
		},

		async postAccountChangeEmail(fields: AccountChangeEmailCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountChangeemailPost.bind(this, fields));
		},

		async postAccountEditProfileImage(fields: AccountEditProfileImageCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountEditprofileimagePost.bind(this, fields));
		},

		async getAccountCertification(id?: string) {
			return request<AccountCertificationQueryResponse>(new AccountApi().apiAccountCertificationGet.bind(this, id));
		},

		async postAuthenticationChangePassword(fields: AuthenticationChangePasswordCommand) {
			return request<SharedModelsCommandResponse>(
				new AuthenticationApi().apiAuthenticationChangepasswordPost.bind(this, fields)
			);
		},

		async postAccountEditPhoneNumber(fields: AccountEditPhoneNumberCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountEditphonenumberPost.bind(this, fields));
		},

		async postAccountVolunteerRemove(fields: AccountVolunteerRevokeCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountVolunteerremovePost.bind(this, fields));
		},

		async postAccountVolunteerRequest(fields: AccountVolunteerRequestCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountVolunteerrequestPost.bind(this, fields));
		},

		async postAccountVolunteerRevoke(fields: AccountVolunteerRevokeCommand) {
			return request<SharedModelsCommandResponse>(new AccountApi().apiAccountVolunteerrevokePost.bind(this, fields));
		},

		// STAFF
		async getStaffData() {
			return request<StaffDashboardResponse>(new StaffApi().apiStaffDashboardGet.bind(this));
		},

		async getStaffProfileData(id: string) {
			return request<StaffFetchResponse>(new StaffApi().apiStaffFetchGet.bind(this, id));
		},

		async getStaffPast(id: string) {
			return request<StaffPastResponse>(new StaffApi().apiStaffPastGet.bind(this, id));
		},

		async assignStaffOrganisationRole(fields: StaffStaffTypeCommand) {
			return request<SharedModelsCommandResponse>(new StaffApi().apiStaffStafftypePost.bind(this, fields));
		},

		async disableStaff(fields: StaffDisableProfileCommand) {
			return request<SharedModelsCommandResponse>(new StaffApi().apiStaffDisableprofilePost.bind(this, fields));
		},

		async postStaffReinstateProfile(fields: StaffReinstateProfileCommand) {
			return request<SharedModelsCommandResponse>(new StaffApi().apiStaffReinstateprofilePost.bind(this, fields));
		},

		async assignOrganisationAdminStatus(fields: StaffOrganisationAdminCommand) {
			return request<SharedModelsCommandResponse>(new StaffApi().apiStaffOrganisationadminPost.bind(this, fields));
		},

		async postStaffReference(fields: StaffReferenceCommand) {
			return request<SharedModelsCommandIdResponse>(new StaffApi().apiStaffReferencePost.bind(this, fields));
		},

		async getStaffReference(id?: string) {
			return request<StaffReferenceQueryResponse>(new StaffApi().apiStaffReferenceGet.bind(this, id));
		},

		// LEADERSHIP
		async getLeadershipTeamData() {
			return request<LeadershipTeamMembersResponse>(new LeadershipTeamApi().apiLeadershipteamMembersGet.bind(this));
		},

		async removeLeadershipTeamMember(fields: LeadershipTeamUnAssignCommand) {
			return request<SharedModelsCommandResponse>(
				new LeadershipTeamApi().apiLeadershipteamUnassignPost.bind(this, fields)
			);
		},

		async searchLeadershipTeamMember(searchTerm: string) {
			return request<LeadershipTeamSearchResponse>(
				new LeadershipTeamApi().apiLeadershipteamSearchGet.bind(this, searchTerm)
			);
		},

		async addLeadershipTeamMember(fields: LeadershipTeamAssignCommand) {
			return request<SharedModelsCommandResponse>(
				new LeadershipTeamApi().apiLeadershipteamAssignPost.bind(this, fields)
			);
		},

		// FAMILIES
		async getFamiliesData() {
			return request<FamiliesDashboardResponse>(new FamiliesApi().apiFamiliesDashboardGet.bind(this));
		},

		async getFamiliesProfileData(id?: string) {
			return request<FamiliesFetchResponse>(new FamiliesApi().apiFamiliesFetchGet.bind(this, id));
		},

		async getFamiliesPast(id?: string) {
			return request<FamiliesPastResponse>(new FamiliesApi().apiFamiliesPastGet.bind(this, id));
		},

		async disableFamilyMember(fields: FamiliesDisableProfileCommand) {
			return request<SharedModelsCommandResponse>(new FamiliesApi().apiFamiliesDisableprofilePost.bind(this, fields));
		},

		async postFamiliesReinstateProfile(fields: FamiliesReinstateProfileCommand) {
			return request<SharedModelsCommandResponse>(new FamiliesApi().apiFamiliesReinstateprofilePost.bind(this, fields));
		},

		// VISITORS
		async getVisitorsData() {
			return request<VisitorsDashboardResponse>(new VisitorsApi().apiVisitorsDashboardGet.bind(this));
		},

		async getVisitorsProfileData(id?: string) {
			return request<VisitorsFetchResponse>(new VisitorsApi().apiVisitorsFetchGet.bind(this, id));
		},

		async getVisitorsPast(id?: string) {
			return request<VisitorsPastResponse>(new VisitorsApi().apiVisitorsPastGet.bind(this, id));
		},

		async disableVisitor(fields: VisitorsDisableProfileCommand) {
			return request<SharedModelsCommandResponse>(new VisitorsApi().apiVisitorsDisableprofilePost.bind(this, fields));
		},

		async postVisitorsReinstateProfile(fields: VisitorsReinstateProfileCommand) {
			return request<SharedModelsCommandResponse>(new VisitorsApi().apiVisitorsReinstateprofilePost.bind(this, fields));
		},

		// REQUESTS TO JOIN
		async getRequestsToJoinData() {
			return request<RequestsToJoinPendingRequestsResponse>(
				new RequestsToJoinApi().apiRequeststojoinPendingrequestsGet.bind(this)
			);
		},

		async getRequestsToJoinDetailData(profileId: string) {
			return request<RequestsToJoinFetchResponse>(
				new RequestsToJoinApi().apiRequeststojoinFetchGet.bind(this, profileId)
			);
		},

		async assignRequestsToJoinOrganisationRole(fields: RequestsToJoinStaffTypeCommand) {
			return request<SharedModelsCommandResponse>(
				new RequestsToJoinApi().apiRequeststojoinStafftypePost.bind(this, fields)
			);
		},

		async assignRequestsToJoinOrganisationAdminStatus(fields: RequestsToJoinOrganisationAdminCommand) {
			return request<SharedModelsCommandResponse>(
				new RequestsToJoinApi().apiRequeststojoinOrganisationadminPost.bind(this, fields)
			);
		},

		async approveRequestsToJoin(fields: RequestsToJoinApproveCommand) {
			return request<SharedModelsCommandResponse>(
				new RequestsToJoinApi().apiRequeststojoinApprovePost.bind(this, fields)
			);
		},

		async denyRequestsToJoin(fields: RequestsToJoinDenyCommand) {
			return request<SharedModelsCommandResponse>(new RequestsToJoinApi().apiRequeststojoinDenyPost.bind(this, fields));
		},

		async confirmDocumentsCited(fields: RequestsToJoinCiteCertificationCommand) {
			return request<SharedModelsCommandResponse>(
				new RequestsToJoinApi().apiRequeststojoinCitecertificationPost.bind(this, fields)
			);
		},

		async getCertificationDetail(id: string, profileId: string) {
			return request<RequestsToJoinReviewCertificationResponse>(
				new RequestsToJoinApi().apiRequeststojoinReviewcertificationGet.bind(this, id, profileId)
			);
		},

		async postRequestsToJoinVolunteerApprove(fields: RequestsToJoinVolunteerApproveCommand) {
			return request<SharedModelsCommandResponse>(
				new RequestsToJoinApi().apiRequeststojoinVolunteerapprovePost.bind(this, fields)
			);
		},

		async postRequestsToJoinVolunteerDeny(fields: RequestsToJoinVolunteerDenyCommand) {
			return request<SharedModelsCommandResponse>(
				new RequestsToJoinApi().apiRequeststojoinVolunteerdenyPost.bind(this, fields)
			);
		},

		// INVITE TO JOIN
		async getInviteToJoinsData() {
			return request<InviteInviteLinksResponse>(new InviteApi().apiInviteInvitelinksGet.bind(this));
		},

		// CHILD SAFE STANDARDS SUPER ADMIN
		async getChildSafeStandardDashboard() {
			return request<ChildSafeStandardAdminDashboardResponse>(
				new ChildSafeStandardApi().apiChildsafestandardAdmindashboardGet.bind(this)
			);
		},

		async getChildSafeStandardEdit(id?: string) {
			return request<ChildSafeStandardEditQueryResponse>(
				new ChildSafeStandardApi().apiChildsafestandardEditGet.bind(this, id)
			);
		},

		async postChildSafeStandardEdit(fields: ChildSafeStandardEditCommand) {
			return request<SharedModelsCommandIdResponse>(
				new ChildSafeStandardApi().apiChildsafestandardEditPost.bind(this, fields)
			);
		},

		async postChildSafeStandardDelete(fields: ChildSafeStandardDeleteCommand) {
			return request<SharedModelsCommandResponse>(
				new ChildSafeStandardApi().apiChildsafestandardDeletePost.bind(this, fields)
			);
		},

		async postChildSafeStandardReorder(fields: ChildSafeStandardReorderCommand) {
			return request<SharedModelsCommandResponse>(
				new ChildSafeStandardApi().apiChildsafestandardReorderPost.bind(this, fields)
			);
		},

		// CHILD SAFE STANDARDS
		async getChildSafeStandardsData() {
			return request<ChildSafeStandardUserDashboardResponse>(
				new ChildSafeStandardApi().apiChildsafestandardUserdashboardGet.bind(this)
			);
		},

		async getChildSafeStandardsDetailData(id?: string) {
			return request<ChildSafeStandardFetchResponse>(
				new ChildSafeStandardApi().apiChildsafestandardFetchGet.bind(this, id)
			);
		},

		// POLICIES SUPER ADMIN
		// async getPolicyTemplateAsset(id?: string) {
		// 	return request(new PolicyTemplateApi().apiPolicytemplateAssetGet.bind(this, id));
		// },

		async getPolicyTemplateDashboard() {
			return request<PolicyTemplateDashboardResponse>(new PolicyTemplateApi().apiPolicytemplateDashboardGet.bind(this));
		},

		async getPolicyTemplateEdit(id?: string) {
			return request<PolicyTemplateEditQueryResponse>(new PolicyTemplateApi().apiPolicytemplateEditGet.bind(this, id));
		},

		async postPolicyTemplateEdit(fields: PolicyTemplateEditCommand) {
			return request<SharedModelsCommandIdResponse>(
				new PolicyTemplateApi().apiPolicytemplateEditPost.bind(this, fields)
			);
		},

		async postPolicyTemplateDelete(fields: PolicyTemplateDeleteCommand) {
			return request<SharedModelsCommandResponse>(
				new PolicyTemplateApi().apiPolicytemplateDeletePost.bind(this, fields)
			);
		},

		async postPolicyTemplateReorder(fields: PolicyTemplateReorderCommand) {
			return request<SharedModelsCommandResponse>(
				new PolicyTemplateApi().apiPolicytemplateReorderPost.bind(this, fields)
			);
		},

		// POLICIES
		async getPoliciesAdminData() {
			return request<PolicyAdminDashboardResponse>(new PolicyApi().apiPolicyAdmindashboardGet.bind(this));
		},

		async getPoliciesUserData() {
			return request<PolicyUserDashboardResponse>(new PolicyApi().apiPolicyUserdashboardGet.bind(this));
		},

		async getPoliciesDetailsData(id: string) {
			return request<PolicyEditQueryResponse>(new PolicyApi().apiPolicyEditGet.bind(this, id));
		},

		async submitPolicy(fields: PolicyEditCommand) {
			return request<SharedModelsCommandIdResponse>(new PolicyApi().apiPolicyEditPost.bind(this, fields));
		},

		async getPolicyTemplatesData() {
			return request<PolicyPolicyTemplatesResponse>(new PolicyApi().apiPolicyPolicytemplatesGet.bind(this));
		},

		async archivePolicy(fields: PolicyArchiveCommand) {
			return request<SharedModelsCommandResponse>(new PolicyApi().apiPolicyArchivePost.bind(this, fields));
		},

		async reInstatePolicy(fields: PolicyReinstateCommand) {
			return request<SharedModelsCommandResponse>(new PolicyApi().apiPolicyReinstatePost.bind(this, fields));
		},

		async acceptPolicy(fields: PolicyAcknowledgeCommand) {
			return request<SharedModelsCommandResponse>(new PolicyApi().apiPolicyAcknowledgePost.bind(this, fields));
		},

		async postPolicyReinstate(fields: PolicyReinstateCommand) {
			return request<SharedModelsCommandResponse>(new PolicyApi().apiPolicyReinstatePost.bind(this, fields));
		},

		// TRAINING
		async getTrainingAdminDashboard() {
			return request<TrainingAdminDashboardResponse>(new TrainingApi().apiTrainingAdmindashboardGet.bind(this));
		},

		async postTrainingEdit(fields: TrainingEditCommand) {
			return request<SharedModelsCommandIdResponse>(new TrainingApi().apiTrainingEditPost.bind(this, fields));
		},

		async getTrainingView(id?: string) {
			return request<TrainingViewResponse>(new TrainingApi().apiTrainingViewGet.bind(this, id));
		},

		async postTrainingRemove(fields: TrainingRemoveCommand) {
			return request<SharedModelsCommandResponse>(new TrainingApi().apiTrainingRemovePost.bind(this, fields));
		},

		async getTrainingUserDashboard() {
			return request<TrainingUserDashboardResponse>(new TrainingApi().apiTrainingUserdashboardGet.bind(this));
		},

		async getAdditionalTrainingDetail(id?: string) {
			return request<TrainingAdditionalTrainingEditQueryResponse>(
				new TrainingApi().apiTrainingAdditionaltrainingeditGet.bind(this, id)
			);
		},

		async postTrainingAdditionalTrainingEdit(fields: TrainingAdditionalTrainingEditCommand) {
			return request<SharedModelsCommandResponse>(
				new TrainingApi().apiTrainingAdditionaltrainingeditPost.bind(this, fields)
			);
		},

		async postTrainingMarkAsComplete(fields: TrainingMarkAsCompleteCommand) {
			return request<SharedModelsCommandResponse>(new TrainingApi().apiTrainingMarkascompletePost.bind(this, fields));
		},

		async submitOrganisationNewTrainingModule(fields: TrainingEditModuleCommand) {
			return request<SharedModelsCommandResponse>(new TrainingApi().apiTrainingEditmodulePost.bind(this, fields));
		},

		async getOrganisationNewTrainingModule(id?: string) {
			return request<TrainingEditModuleQueryResponse>(new TrainingApi().apiTrainingEditmoduleGet.bind(this, id));
		},

		async deleteOrganisationNewTrainingModule(fields: TrainingDeleteModuleCommand) {
			return request<SharedModelsCommandResponse>(new TrainingApi().apiTrainingDeletemodulePost.bind(this, fields));
		},

		// SAFETY CHECKLIST
		// async getSafetyChecklistAsset(id?: string) {
		// 	return request<void>(new SafetyChecklistApi().apiSafetychecklistAssetGet.bind(this, id));
		// },

		async getSafetyChecklistsTemplates() {
			return request<SafetyChecklistTemplatesResponse>(
				new SafetyChecklistApi().apiSafetychecklistTemplatesGet.bind(this)
			);
		},

		async getSafetyChecklistTemplate(templateId?: string, checklistId?: string) {
			return request<SafetyChecklistTemplateResponse>(
				new SafetyChecklistApi().apiSafetychecklistTemplateGet.bind(this, templateId, checklistId)
			);
		},

		async getAdminSafetyChecklistDashboard() {
			return request<SafetyChecklistAdminDashboardResponse>(
				new SafetyChecklistApi().apiSafetychecklistAdmindashboardGet.bind(this)
			);
		},

		async getUserSafetyChecklistDashboard() {
			return request<SafetyChecklistUserDashboardResponse>(
				new SafetyChecklistApi().apiSafetychecklistUserdashboardGet.bind(this)
			);
		},

		async getSafetyChecklistEdit(checklistId?: string, templateId?: string, checklistTemplateId?: string) {
			return request<SafetyChecklistEditQueryResponse>(
				new SafetyChecklistApi().apiSafetychecklistEditGet.bind(this, checklistId, templateId, checklistTemplateId)
			);
		},

		async postSafetyChecklistEdit(fields: SafetyChecklistEditCommand) {
			return request<SharedModelsCommandIdResponse>(
				new SafetyChecklistApi().apiSafetychecklistEditPost.bind(this, fields)
			);
		},

		async getSafetyChecklistChecklist(id?: string) {
			return request<SafetyChecklistChecklistResponse>(
				new SafetyChecklistApi().apiSafetychecklistChecklistGet.bind(this, id)
			);
		},

		async getSafetyChecklistComment(id?: string) {
			return request<SafetyChecklistCommentQueryResponse>(
				new SafetyChecklistApi().apiSafetychecklistCommentGet.bind(this, id)
			);
		},

		async postSafetyChecklistComment(fields: SafetyChecklistCommentCommand) {
			return request<SharedModelsCommandResponse>(
				new SafetyChecklistApi().apiSafetychecklistCommentPost.bind(this, fields)
			);
		},

		async getSafetyChecklistAttachments(id?: string) {
			return request<SafetyChecklistAttachmentsResponse>(
				new SafetyChecklistApi().apiSafetychecklistAttachmentsGet.bind(this, id)
			);
		},

		async postSafetyChecklistAttachmentUpload(fields: SafetyChecklistAttachmentUploadCommand) {
			return request<SharedModelsCommandResponse>(
				new SafetyChecklistApi().apiSafetychecklistAttachmentuploadPost.bind(this, fields)
			);
		},

		async postSafetyChecklistAttachmentDelete(fields: SafetyChecklistAttachmentDeleteCommand) {
			return request<SharedModelsCommandResponse>(
				new SafetyChecklistApi().apiSafetychecklistAttachmentdeletePost.bind(this, fields)
			);
		},

		async postSafetyChecklistSubmit(fields: SafetyChecklistSubmitCommand) {
			return request<SharedModelsCommandResponse>(
				new SafetyChecklistApi().apiSafetychecklistSubmitPost.bind(this, fields)
			);
		},

		async postSafetyChecklistApprove(fields: SafetyChecklistApproveCommand) {
			return request<SharedModelsCommandResponse>(
				new SafetyChecklistApi().apiSafetychecklistApprovePost.bind(this, fields)
			);
		},

		async getSafetyChecklistApprovers() {
			return request<SafetyChecklistApproversResponse>(
				new SafetyChecklistApi().apiSafetychecklistApproversGet.bind(this)
			);
		},

		async postSafetyChecklistAction(fields: SafetyChecklistActionCommand) {
			return request<SharedModelsCommandResponse>(
				new SafetyChecklistApi().apiSafetychecklistActionPost.bind(this, fields)
			);
		},

		// async getSafetyChecklistSummaryPdf(id?: string) {
		// 	return request<void>(new SafetyChecklistApi().apiSafetychecklistSummarypdfassetGet.bind(this, id));
		// },

		// SUPER ADMIN CHECKLISTS
		async getChecklistTemplateDashboard() {
			return request<ChecklistTemplateDashboardResponse>(
				new ChecklistTemplateApi().apiChecklisttemplateDashboardGet.bind(this)
			);
		},

		async postChecklistTemplateEdit(fields: ChecklistTemplateEditCommand) {
			return request<SharedModelsCommandIdResponse>(
				new ChecklistTemplateApi().apiChecklisttemplateEditPost.bind(this, fields)
			);
		},

		async getChecklistTemplateEdit(id?: string) {
			return request<ChecklistTemplateEditQueryResponse>(
				new ChecklistTemplateApi().apiChecklisttemplateEditGet.bind(this, id)
			);
		},

		async postChecklistTemplateDelete(fields: ChecklistTemplateDeleteCommand) {
			return request<SharedModelsCommandResponse>(
				new ChecklistTemplateApi().apiChecklisttemplateDeletePost.bind(this, fields)
			);
		},

		async postChecklistTemplateReorder(fields: ChecklistTemplateReorderCommand) {
			return request<SharedModelsCommandResponse>(
				new ChecklistTemplateApi().apiChecklisttemplateReorderPost.bind(this, fields)
			);
		},

		// FEEDBACK
		async getAdminFeedbackData() {
			return request<FeedbackAdminDashboardResponse>(new FeedbackApi().apiFeedbackAdmindashboardGet.bind(this));
		},

		async getUserFeedbackData() {
			return request<FeedbackUserDashboardResponse>(new FeedbackApi().apiFeedbackUserdashboardGet.bind(this));
		},

		async getFeedbackDetailsData(id: string) {
			return request<FeedbackFetchResponse>(new FeedbackApi().apiFeedbackFetchGet.bind(this, id));
		},

		async getFeedbackProgress(id: string) {
			return request<FeedbackActionsResponse>(new FeedbackApi().apiFeedbackActionsGet.bind(this, id));
		},

		async logFeedbackProgress(fields: FeedbackLogActionCommand) {
			return request<SharedModelsCommandResponse>(new FeedbackApi().apiFeedbackLogactionPost.bind(this, fields));
		},

		async createFeedback(fields: FeedbackCreateCommand) {
			return request<SharedModelsCommandResponse>(new FeedbackApi().apiFeedbackCreatePost.bind(this, fields));
		},

		async resolveFeedback(fields: FeedbackResolveCommand) {
			return request<SharedModelsCommandResponse>(new FeedbackApi().apiFeedbackResolvePost.bind(this, fields));
		},

		async withdrawFeedback(fields: FeedbackWithdrawCommand) {
			return request<SharedModelsCommandResponse>(new FeedbackApi().apiFeedbackWithdrawPost.bind(this, fields));
		},

		// INCIDENT REPORT
		async getAdminIncidentReportsData() {
			return request<IncidentAdminDashboardResponse>(new IncidentApi().apiIncidentAdmindashboardGet.bind(this));
		},

		async getUserIncidentReportsData() {
			return request<IncidentUserDashboardResponse>(new IncidentApi().apiIncidentUserdashboardGet.bind(this));
		},

		async getIncidentReportsDetailsDataArchive(id: string) {
			return request<IncidentArchiveEditQueryResponse>(
				new IncidentArchiveApi().apiIncidentarchiveEditGet.bind(this, id)
			);
		},

		async getIncidentReportsDetailsData(id: string) {
			return request<IncidentEditQueryResponse>(new IncidentApi().apiIncidentEditGet.bind(this, id));
		},

		async acknowledgeYourselfArchive(fields: IncidentArchiveAcknowledgeCommand) {
			return request<SharedModelsCommandResponse>(
				new IncidentArchiveApi().apiIncidentarchiveAcknowledgePost.bind(this, fields)
			);
		},

		async acknowledgeYourself(fields: IncidentAcknowledgeCommand) {
			return request<SharedModelsCommandResponse>(new IncidentApi().apiIncidentAcknowledgePost.bind(this, fields));
		},

		async getAcceptModalDetailArchive(id?: string) {
			return request<IncidentArchiveAcknowledgeOnBehalfQueryResponse>(
				new IncidentArchiveApi().apiIncidentarchiveAcknowledgeonbehalfGet.bind(this, id)
			);
		},

		async getAcceptModalDetail(id?: string) {
			return request<IncidentAcknowledgeOnBehalfQueryResponse>(
				new IncidentApi().apiIncidentAcknowledgeonbehalfGet.bind(this, id)
			);
		},

		async acceptAcknowledgementArchive(fields: IncidentArchiveAcknowledgeOnBehalfCommand) {
			return request<SharedModelsCommandResponse>(
				new IncidentArchiveApi().apiIncidentarchiveAcknowledgeonbehalfPost.bind(this, fields)
			);
		},

		async acceptAcknowledgement(fields: IncidentAcknowledgeOnBehalfCommand) {
			return request<SharedModelsCommandResponse>(
				new IncidentApi().apiIncidentAcknowledgeonbehalfPost.bind(this, fields)
			);
		},

		async searchOthersRecipientsArchive(searchTerm: string) {
			return request<IncidentArchiveRecipientsResponse>(
				new IncidentArchiveApi().apiIncidentarchiveRecipientsGet.bind(this, searchTerm)
			);
		},

		async searchOthersRecipients(searchTerm: string) {
			return request<IncidentRecipientsResponse>(new IncidentApi().apiIncidentRecipientsGet.bind(this, searchTerm));
		},

		// Archive Incident Report Submit
		async createIncidentReport(fields: IncidentArchiveEditCommand) {
			return request<SharedModelsCommandIdResponse>(
				new IncidentArchiveApi().apiIncidentarchiveEditPost.bind(this, fields)
			);
		},

		// Incident Report Submit
		async submitIncidentReport(fields: IncidentEditCommand) {
			return request<SharedModelsCommandIdResponse>(new IncidentApi().apiIncidentEditPost.bind(this, fields));
		},

		// Archive Incident Report
		async loadIncidentReportArchive(id?: string) {
			return request<IncidentArchiveEditQueryResponse>(
				new IncidentArchiveApi().apiIncidentarchiveEditGet.bind(this, id)
			);
		},

		async loadIncidentReport(id?: string) {
			return request<IncidentEditQueryResponse>(new IncidentApi().apiIncidentEditGet.bind(this, id));
		},

		// Archive Link Request
		async getIncidentLinkRequestArchive(recipientId?: string) {
			return request<IncidentArchiveLinkRequestResponse>(
				new IncidentArchiveApi().apiIncidentarchiveLinkrequestGet.bind(this, recipientId)
			);
		},

		async getIncidentLinkRequest(recipientId?: string) {
			return request<IncidentLinkRequestResponse>(new IncidentApi().apiIncidentLinkrequestGet.bind(this, recipientId));
		},

		async postIncidentLinkIncidentArchive(fields: IncidentArchiveLinkIncidentCommand) {
			return request<SharedModelsCommandResponse>(
				new IncidentArchiveApi().apiIncidentarchiveLinkincidentPost.bind(this, fields)
			);
		},

		async postIncidentLinkIncident(fields: IncidentLinkIncidentCommand) {
			return request<SharedModelsCommandResponse>(new IncidentApi().apiIncidentLinkincidentPost.bind(this, fields));
		},

		// COMPLAINTS SUPER ADMIN
		async getComplaintAdviceDashboard() {
			return request<ComplaintAdviceDashboardResponse>(
				new ComplaintAdviceApi().apiComplaintadviceDashboardGet.bind(this)
			);
		},

		async getComplaintAdviceEdit(id?: string) {
			return request<ComplaintAdviceEditResponse>(new ComplaintAdviceApi().apiComplaintadviceEditGet.bind(this, id));
		},

		async postComplaintAdviceEdit(fields: ComplaintAdviceEditCommand) {
			return request<SharedModelsCommandResponse>(
				new ComplaintAdviceApi().apiComplaintadviceEditPost.bind(this, fields)
			);
		},

		async postComplaintAdviceDelete(fields: ComplaintAdviceDeleteCommand) {
			return request<SharedModelsCommandResponse>(
				new ComplaintAdviceApi().apiComplaintadviceDeletePost.bind(this, fields)
			);
		},

		async postComplaintAdviceReorder(fields: ComplaintAdviceReorderCommand) {
			return request<SharedModelsCommandResponse>(
				new ComplaintAdviceApi().apiComplaintadviceReorderPost.bind(this, fields)
			);
		},

		// async getComplaintAdviceAsset(id?: string) {
		// 	return request<void>(new ComplaintAdviceApi().apiComplaintadviceAssetGet.bind(this, id));
		// },

		// COMPLAINTS
		async getAdminComplaintsData() {
			return request<ComplaintAdminDashboardResponse>(new ComplaintApi().apiComplaintAdmindashboardGet.bind(this));
		},

		async getUserComplaintsData() {
			return request<ComplaintUserDashboardResponse>(new ComplaintApi().apiComplaintUserdashboardGet.bind(this));
		},

		async getComplaintsNotifiedMembersList() {
			return request<ComplaintMemberCandidatesResponse>(new ComplaintApi().apiComplaintMembercandidatesGet.bind(this));
		},

		async submitComplaint(fields: ComplaintCreateCommand) {
			return request<SharedModelsCommandIdResponse>(new ComplaintApi().apiComplaintCreatePost.bind(this, fields));
		},

		async getComplaintsDetailsData(id: string) {
			return request<ComplaintFetchResponse>(new ComplaintApi().apiComplaintFetchGet.bind(this, id));
		},

		async resolveComplaint(fields: ComplaintResolutionCommand) {
			return request<SharedModelsCommandResponse>(new ComplaintApi().apiComplaintResolutionPost.bind(this, fields));
		},

		async getComplaintResolution(id?: string) {
			return request<ComplaintResolutionResponse>(new ComplaintApi().apiComplaintResolutionGet.bind(this, id));
		},

		async getComplaintsAdviceData() {
			return request<ComplaintComplaintAdviceResponse>(new ComplaintApi().apiComplaintComplaintadviceGet.bind(this));
		},

		async getComplaintsProgress(id?: string) {
			return request<ComplaintActionsResponse>(new ComplaintApi().apiComplaintActionsGet.bind(this, id));
		},

		async logComplaintsProgress(fields: ComplaintEditActionCommand) {
			return request<SharedModelsCommandIdResponse>(new ComplaintApi().apiComplaintEditactionPost.bind(this, fields));
		},

		async removeComplaintsProgress(fields: ComplaintRemoveActionCommand) {
			return request<SharedModelsCommandResponse>(new ComplaintApi().apiComplaintRemoveactionPost.bind(this, fields));
		},

		async getResolutionReviewDetail(id?: string) {
			return request<ComplaintAcceptResolutionQueryResponse>(
				new ComplaintApi().apiComplaintAcceptresolutionGet.bind(this, id)
			);
		},

		async acceptResolution(fields: ComplaintAcceptResolutionCommand) {
			return request<SharedModelsCommandResponse>(
				new ComplaintApi().apiComplaintAcceptresolutionPost.bind(this, fields)
			);
		},

		async reOpenComplaint(fields: ComplaintReopenCommand) {
			return request<SharedModelsCommandResponse>(new ComplaintApi().apiComplaintReopenPost.bind(this, fields));
		},

		async withdrawComplaint(fields: ComplaintWithdrawCommand) {
			return request<SharedModelsCommandResponse>(new ComplaintApi().apiComplaintWithdrawPost.bind(this, fields));
		},

		async searchComplaintResolveStaffMember(id: string, searchTerm: string) {
			return request<ComplaintStaffCandidatesResponse>(
				new ComplaintApi().apiComplaintStaffcandidatesGet.bind(this, id, searchTerm)
			);
		},

		async addComplaintResolveStaffMember(fields: ComplaintAddStaffCommand) {
			return request<SharedModelsCommandResponse>(new ComplaintApi().apiComplaintAddstaffPost.bind(this, fields));
		},

		async removeFamilyMember(fields: ComplaintRemoveFamilyMemberCommand) {
			return request<SharedModelsCommandResponse>(
				new ComplaintApi().apiComplaintRemovefamilymemberPost.bind(this, fields)
			);
		},

		// AUDITS
		async getAuditId() {
			return request<SharedModelsCommandIdResponse>(new AuditApi().apiAuditGeneratePost.bind(this));
		},

		async getAuditReport(id: string) {
			return request<AuditReadyResponse>(new AuditApi().apiAuditReadyGet.bind(this, id));
		},

		async cancelPlan() {
			return request<SharedModelsCommandResponse>(new OrganisationApi().apiOrganisationCancelplanPost.bind(this));
		},

		// SETTING
		async getOrganisationDetail() {
			return request<OrganisationSettingsResponse>(new OrganisationApi().apiOrganisationSettingsGet.bind(this));
		},

		async getOrganisationAddress() {
			return request<OrganisationAddressQueryResponse>(new OrganisationApi().apiOrganisationAddressGet.bind(this));
		},

		async submitOrganisationAddress(fields: OrganisationAddressCommand) {
			return request<SharedModelsCommandResponse>(new OrganisationApi().apiOrganisationAddressPost.bind(this, fields));
		},

		async submitOrganisationLogo(fields: OrganisationEditProfileImageCommand) {
			return request<SharedModelsCommandResponse>(
				new OrganisationApi().apiOrganisationEditprofileimagePost.bind(this, fields)
			);
		},

		async getPaymentUpdateLink() {
			return request<PaymentCreateResponse>(new PaymentApi().apiPaymentCustomerPost.bind(this));
		},

		async updateNumberOfChildren(fields: OrganisationNumberOfChildrenCommand) {
			return request<SharedModelsCommandResponse>(
				new OrganisationApi().apiOrganisationNumberofchildrenPost.bind(this, fields)
			);
		},

		async getOrganistationProfileCheck({
			organisationIdentifier,
			profileType
		}: {
			organisationIdentifier?: string;
			profileType?: DomainProfileType;
		}) {
			return request<OrganisationProfileCheckResponse>(
				new OrganisationApi().apiOrganisationProfilecheckGet.bind(this, organisationIdentifier, profileType)
			);
		},

		// HELP DESK
		async getHelpDeskData() {
			return request<HelpDeskUserDashboardResponse>(new HelpDeskApi().apiHelpdeskUserdashboardGet.bind(this));
		},

		async getHelpDeskDetailData(id?: string) {
			return request<HelpDeskFetchResponse>(new HelpDeskApi().apiHelpdeskFetchGet.bind(this, id));
		},

		// HELP DESK SUPER ADMIN
		async getHelpDeskAdminDashboard() {
			return request<HelpDeskAdminDashboardResponse>(new HelpDeskApi().apiHelpdeskAdmindashboardGet.bind(this));
		},

		async getHelpDeskAdminDetailData(id?: string) {
			return request<HelpDeskEditQueryResponse>(new HelpDeskApi().apiHelpdeskEditGet.bind(this, id));
		},

		async postHelpDeskEdit(fields: HelpDeskEditCommand) {
			return request<SharedModelsCommandIdResponse>(new HelpDeskApi().apiHelpdeskEditPost.bind(this, fields));
		},

		async postHelpDeskDelete(fields: HelpDeskDeleteCommand) {
			return request<SharedModelsCommandResponse>(new HelpDeskApi().apiHelpdeskDeletePost.bind(this, fields));
		},

		async postHelpDeskReorder(fields: HelpDeskReorderCommand) {
			return request<SharedModelsCommandResponse>(new HelpDeskApi().apiHelpdeskReorderPost.bind(this, fields));
		},

		// COMPANIES
		async getCompaniesData() {
			return request<OrganisationListResponse>(new OrganisationApi().apiOrganisationListGet.bind(this));
		},

		async getCompaniesDetailData(id?: string) {
			return request<OrganisationDetailsResponse>(new OrganisationApi().apiOrganisationDetailsGet.bind(this, id));
		},

		async postOrganisationDeactivate(fields: OrganisationDeactivateCommand) {
			return request<SharedModelsCommandResponse>(
				new OrganisationApi().apiOrganisationDeactivatePost.bind(this, fields)
			);
		},

		async postOrganisationActivate(fields: OrganisationActivateCommand) {
			return request<SharedModelsCommandResponse>(new OrganisationApi().apiOrganisationActivatePost.bind(this, fields));
		},

		async getOrganisationAdminCandidates(organisationId?: string, searchTerm?: string) {
			return request<OrganisationAdministratorCandidatesResponse>(
				new OrganisationApi().apiOrganisationAdministratorcandidatesGet.bind(this, organisationId, searchTerm)
			);
		},

		async getOrganisationAdministrators(organisationId?: string) {
			return request<OrganisationAdministratorsResponse>(
				new OrganisationApi().apiOrganisationAdministratorsGet.bind(this, organisationId)
			);
		},

		async postOrganisationAddAdmin(fields: OrganisationAddAdministratorCommand) {
			return request<SharedModelsCommandResponse>(
				new OrganisationApi().apiOrganisationAddadministratorPost.bind(this, fields)
			);
		},

		async postOrganisationRemoveAdmin(fields: OrganisationRemoveAdministratorCommand) {
			return request<SharedModelsCommandResponse>(
				new OrganisationApi().apiOrganisationRemoveadministratorPost.bind(this, fields)
			);
		},

		// SUPER ADMIN TRAINING MODULES
		async getTrainingModuleDashboard() {
			return request<TrainingModuleDashboardResponse>(new TrainingModuleApi().apiTrainingmoduleDashboardGet.bind(this));
		},

		async getTrainingModuleEdit(id?: string) {
			return request<TrainingModuleEditQueryResponse>(new TrainingModuleApi().apiTrainingmoduleEditGet.bind(this, id));
		},

		async postTrainingModuleEdit(fields: TrainingModuleEditCommand) {
			return request<SharedModelsCommandIdResponse>(
				new TrainingModuleApi().apiTrainingmoduleEditPost.bind(this, fields)
			);
		},

		async postTrainingModuleReorder(fields: TrainingModuleReorderCommand) {
			return request<SharedModelsCommandResponse>(
				new TrainingModuleApi().apiTrainingmoduleReorderPost.bind(this, fields)
			);
		},

		async postTrainingModuleDelete(fields: TrainingModuleDeleteCommand) {
			return request<SharedModelsCommandResponse>(
				new TrainingModuleApi().apiTrainingmoduleDeletePost.bind(this, fields)
			);
		},

		// WWCC API
		async postWorkingwithchildrencheckSinglestatuscheck(fields: WorkingWithChildrenCheckSingleStatusCheckCommand) {
			return request(
				new WorkingWithChildrenCheckApi().apiWorkingwithchildrencheckSinglestatuscheckPost.bind(this, fields)
			);
		},

		// Incomplete Profiles
		async getIncompleteprofileAdmindashboard() {
			return request(new IncompleteProfileApi().apiIncompleteprofileAdmindashboardGet.bind(this));
		},

		// Contact Download
		async getDashboardContactlistdownload() {
			return request(new DashboardApi().apiDashboardContactlistdownloadGet.bind(this));
		}
	};
};

export default api();
